import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    async getMeanTimeSummary(request, accessToken) {
        return await this.execute('post', `/metric/meantime/summary`, request, accessToken);
    }
}
